"use strict";

import angular from "angular";

import template from "./input-value-kpi.component.html";
import "./input-value-kpi.component.scss";

import { FormatUnits } from "../../../presentation/services/FormatUnits/FormatUnits";

class InputValueKpiComponent {
    constructor($filter) {
        this.$filter = $filter;

        this.FormatUnits = new FormatUnits($filter);

        this.averageValue = 0;
    }

    $onInit() {
        this.averageValue = this.unit
            ? this.FormatUnits.formatValue(this.unit, this.average)
            : this.average;
    }

    $onChanges(changes) {
        if (typeof changes.average.previousValue != "object") {
            this.averageValue = this.unit
                ? this.FormatUnits.formatValue(this.unit, this.average)
                : this.average;
        }
    }
}

export { InputValueKpiComponent };

InputValueKpiComponent.$inject = ["$filter"];

const name = "inputValueKpiComponent";
const def = {
    bindings: {
            value: "<",
            average: "<",
            onChangeValue: "&",
            unit: "@"
        },
        controller: InputValueKpiComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
